import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";

// Small pieces the cancel, reschedule and bundle-dates pages share: the way
// back to the booking, and the class the page is about.

export function BackToBooking({ href }: { href: string }) {
  return (
    <a
      href={href}
      className="inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
    >
      <ArrowLeft className="size-4" aria-hidden="true" />
      Back to manage booking
    </a>
  );
}

/** The class: picture, title and a line under it (the current date, the
 * guests). */
export function ClassSummary({ title, thumbnail, children }: { title?: string; thumbnail?: string; children?: ReactNode }) {
  const image = typeof thumbnail === "string" && /^https?:\/\//.test(thumbnail) ? thumbnail : undefined;
  return (
    <div className="flex items-center gap-4 rounded-lg border bg-card p-4">
      {/* eslint-disable-next-line @next/next/no-img-element -- a web component, not a Next page */}
      {image && <img src={image} alt="" className="size-16 shrink-0 rounded-md object-cover" />}
      <div className="min-w-0">
        {title && <p className="truncate font-semibold">{title}</p>}
        {children && <div className="text-sm text-muted-foreground">{children}</div>}
      </div>
    </div>
  );
}
